import React, { useEffect, useLayoutEffect, } from 'react';
import { Link } from 'react-router-dom';

import ErrorAnimation from './ErrorAnimation.jsx'


const ErrorComponent = ({ item }) => {

	useLayoutEffect(() => {
		document.querySelector('body').classList.add('trivia-error-page');
	}, []);

	return (
		<>
			<div className="container my-md-10 my-5">
				<div className="row justify-content-end align-items-center">
					<div className="col-xl-5 col-lg-6 col-md-6">
						<ErrorAnimation />
					</div>
					<div className="col-xl-5 col-lg-6 col-md-6 text-center text-md-start mt-5 mt-md-0">
						<h1 className="error-code" dangerouslySetInnerHTML={{ __html: item.errorCode }}></h1>
						<div className="">
							<h2 className="error-title mt-3 mt-sm-1">{item.title}</h2>

							<Link to={`/trivia`} style={{ width: "fit-content" }} className="mt-5 btn btn-dark px-sm-4 d-flex align-items-center mx-auto mx-md-0">
								<span>Torna alla Homepage</span>
							</Link>
						</div>

					</div>
				</div>
			</div>
		</>
	);
}

export default ErrorComponent;